export const translationOrganizations_en_part3 = {
  orgDetailDeleteOrganizationConfirm: "Delete organization",
  orgDetailUnableToDeleteOrganization: "Unable to delete organization.",
  orgDetailInviteRedirectUrlLabel: "Invite Redirect URL",
  orgDetailInviteRedirectUrlHelp:
    "Users are redirected here after accepting an invitation or finishing registration. Use an approved HTTPS dashboard URL. Leave the field empty to clear it. Invitations stay blocked until a valid URL is set again.",
  orgDetailNameLabel: "Name",
  orgDetailDomainsLabel: "Domains",
  orgDetailDomainsPlaceholder: "acme.com, help.acme.com",
  orgDetailKnowledgeBaseIndexesLabel: "Knowledge Base Indexes",
  orgDetailKnowledgeBaseIndexesHelp:
    "Provide a JSON array. Each entry needs `namespace` and `index_name`. `group` is optional.",
  orgDetailCompanyInfoLabel: "Company Info",
  orgDetailAgentNameLabel: "Agent Name",
  orgDetailProductButtonTextLabel: "Product Button Text",
  orgDetailThumbsRating: "Thumbs Rating",
  orgDetailLivechat: "Livechat",
  orgDetailIntegrations: "Integrations",
  orgDetailUseBrandScope: "Use Brand Scope (internal)",
  orgDetailLivechatNotificationSound: "Livechat Notification Sound",
  orgDetailSaveSettings: "Save Settings",
  orgDetailAssignedChatbots: "Assigned Chatbots",
  orgDetailAssignedChatbotsDescription:
    "These chatbot IDs already belong to this organization. Creation and cloning live on the Chatbots tab in the Organizations view.",
  orgDetailNoChatbotsAssigned: "No chatbots assigned",
  orgDetailAssignedExclusivelyTo: "Assigned exclusively to {organization}",
  orgDetailAvailableToAttach: "Available to Attach",
  orgDetailAvailableToAttachDescription:
    "Only unassigned chatbot IDs can be attached here. Chatbots assigned to another organization are intentionally hidden.",
  orgDetailNoUnassignedChatbots:
    "No unassigned chatbot IDs are available. Create one from the Chatbot IDs page or detach an existing assignment first.",
  // Brands section (OrganizationBrandsSection.tsx)
  // Brands section (OrganizationBrandsSection.tsx)
  brandsUnableToLoad: "Unable to load brands.",
  brandsCreated: "Brand created",
  brandsCouldNotCreate: "Could not create brand.",
  brandsNameCannotBeEmpty: "Name cannot be empty.",
  brandsRenamed: "Brand renamed",
  brandsCouldNotRename: "Could not rename brand.",
  brandsDeleted: "Brand deleted",
  brandsCouldNotDelete: "Could not delete brand.",
  brandsSaved: "Saved",
  brandsCouldNotUpdateChatbot: "Could not update chatbot.",
  brandsTitle: "Brands",
  brandsIntro:
    "Group chatbots in this organization into brands. Users see brands in the scope picker when brand scope is enabled for the organization.",
  brandsListTitle: "Brand list",
  brandsTotalCount: "{count} total",
  brandsNewBrandNamePlaceholder: "New brand name",
  brandsNoBrandsYet: "No brands yet",
  brandsRenameName: "Rename {name}",
  brandsDeleteName: "Delete {name}",
  brandsChatbotAssignmentsTitle: "Chatbot assignments",
  brandsNoChatbotsInOrganization: "No chatbots in this organization",
  brandsSelectBrandPlaceholder: "Select brand",
  brandsUngrouped: "Ungrouped",
  brandsDeleteConfirmTitle: "Delete this brand?",
  brandsDeleteConfirmDescription: "Chatbots in this brand will become ungrouped.",
  orgTypeTitle: "Customer type",
  orgTypeDescription:
    "What the customer sells or does. Product analytics groups and compares customers by it. Diverge admins only; customers never see it.",
  orgTypeMain: "Main type",
  orgTypeExtra: "Extra types",
  orgTypeExtraHelp:
    "Anything else the customer sells or does, such as beauty at a fashion department store. Only filters use them.",
  orgTypeNone: "No type yet",
  orgTypeGroupShops: "Web shops",
  orgTypeGroupOther: "Not a web shop",
  orgTypeGroupExcluded: "Left out of analytics",
  orgTypePickMainFirst: "Pick a main type first",
  orgTypeNoExtra: "None",
  orgTypeSearch: "Find a type",
  orgTypeNoMatch: "No type by that name",
  orgTypeInGroup: "In the analytics group",
  orgTypeMessages: "{count} visitor messages in the last 30 days",
  orgTypeLastChange: "Changed {date} by {who}",
  orgTypeFromList: "the reviewed list",
  orgTypeNotListed: "This organization has no platform record yet, so it can't have a type.",
  orgTypeLoadError: "Could not load the customer types.",
  orgTypeSaveError: "Could not save the customer types. Try again in a moment.",
  orgTypeRetry: "Try again",
  // Language routing (Organizations/languageRouting)
  orgDetailLanguageRoutingTitle: "Language routing",
  orgDetailLanguageRoutingDescription:
    "Load a different chatbot for each page language. The script reads the lang attribute of the page and loads the chatbot routed to that language. Pages in any other language load the main chatbot.",
  orgDetailLanguageRoutingLoadError: "Could not load the language routes.",
  orgDetailLanguageRoutingRetry: "Try again",
  orgDetailLanguageRoutingCurrentTitle: "Current routes",
  orgDetailLanguageRoutingNoRoutes: "No chatbot in this organization has language routes yet.",
  orgDetailLanguageRoutingColumnMain: "Main chatbot",
  orgDetailLanguageRoutingColumnLanguage: "Language",
  orgDetailLanguageRoutingColumnTarget: "Loads chatbot",
  orgDetailLanguageRoutingNeedsTwoChatbots:
    "Language routing needs at least two chatbots in this organization. Attach another chatbot to set it up.",
  orgDetailLanguageRoutingMainLabel: "Main chatbot",
  orgDetailLanguageRoutingMainPlaceholder: "Choose the main chatbot",
  orgDetailLanguageRoutingMainHelp: "The chatbot whose script is on the customer's site.",
  orgDetailLanguageRoutingRoutesLegend: "Languages for {chatbotId}",
  orgDetailLanguageRoutingNoRows: "No languages are routed yet, so every page loads this chatbot.",
  orgDetailLanguageRoutingLanguageLabel: "Language code",
  orgDetailLanguageRoutingLanguagePlaceholder: "sv",
  orgDetailLanguageRoutingTargetLabel: "Chatbot to load",
  orgDetailLanguageRoutingTargetPlaceholder: "Choose a chatbot",
  orgDetailLanguageRoutingRemoveRoute: "Remove the {language} route",
  orgDetailLanguageRoutingRemoveEmptyRoute: "Remove route {number}",
  orgDetailLanguageRoutingAddLanguage: "Add language",
  orgDetailLanguageRoutingSave: "Save routes",
  orgDetailLanguageRoutingSaving: "Saving routes",
  orgDetailLanguageRoutingInvalidLanguage:
    "Use a two or three letter language code, such as sv or de.",
  orgDetailLanguageRoutingDuplicateLanguage: "This language already has a route.",
  orgDetailLanguageRoutingTargetRequired: "Choose the chatbot to load for this language.",
  orgDetailLanguageRoutingFixErrors: "Fix the marked routes, then save again.",
  orgDetailLanguageRoutingSaved: "Language routes saved for {chatbotId}.",
  orgDetailLanguageRoutingSaveError: "Could not save the language routes.",
  orgDetailLanguageRoutingTargetUnavailable:
    "A chatbot to load is no longer in this organization. Reload the page and choose again.",
  orgDetailLanguageRoutingTooManyRoutes: "A chatbot can have at most 100 languages.",
  orgDetailLanguageRoutingMainUnavailable:
    "The main chatbot is no longer in this organization. Reload the page.",
  orgDetailLanguageRoutingSnippetTitle: "Script for the customer's site",
  orgDetailLanguageRoutingSnippetHelp:
    "Routing only runs when the main chatbot's script has {parameter}. Replace the main chatbot's current script with this one on every page.",
};
